<template>
  <div class="password-reset-mail-input-page">
    <sub-header-section :pageTitle="$tc('PasswordResetPage.subTitle')" />

    <password-reset-mail-input-pane @success-regist="moveToSend" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import PasswordResetMailInputPane from '@/components/PasswordResetPage/PasswordResetMailInputPane.vue'

/**
 * パスワードリセット ページ
 */
export default defineComponent({
  name: 'PasswordResetMailInputPage',
  components: {
    SubHeaderSection,
    PasswordResetMailInputPane,
  },
  methods: {
    moveToSend() {
      /**
       * 送信完了画面へ遷移
       * @event success-regist
       */
      this.$router.replace({ path: '/password-reset/mail-sent' })
    },
  },
})
</script>

<style lang="scss" scoped>
.password-reset-mail-input-page {
}
</style>
